module.exports = __webpack_public_path__ + "static/media/soundless.ae57f1be.svg";